import { atom } from 'jotai';
export enum SatelliteTypeEnum {
  S2_MOSAIC = 's2-mosaic',
  S2_MOSAIC_QUARTERLY = 's2-mosaic-quarterly',
  LANDSAT_MOSAIC = 'landsat-mosaic',
  S2_SINGLE = 's2-single',
  PLANET = 'planet',
  LANDSAT = 'landsat',
}

// Atom to store the current record count
export const satelliteRecordCountAtom = atom<number>(0);

interface FilterTriggerContainer {
  trigger: (() => void) | null;
}

// Base atom holding a container object so Jotai never confuses callback functions with state updater functions
const baseSatelliteFilterTriggerAtom = atom<FilterTriggerContainer>({ trigger: null });

// Atom to store and retrieve the filter trigger function.
export const satelliteFilterTriggerAtom = atom(
  (get) => get(baseSatelliteFilterTriggerAtom).trigger,
  (_get, set, update: (() => void) | null | undefined) => {
    set(baseSatelliteFilterTriggerAtom, {
      trigger: typeof update === 'function' ? update : null,
    });
  }
);

// Atom to store the current finder type to coordinate between components
export const currentFinderTypeAtom = atom<SatelliteTypeEnum>(SatelliteTypeEnum.LANDSAT);

export interface SatelliteSearchPoint {
  lng: number;
  lat: number;
  timestamp?: number;
}

// Atom to store the target search point when initiating search from context menu
export const satelliteSearchPointAtom = atom<SatelliteSearchPoint | null>(null);